import {
  Snippet,
  type SnippetTranslations,
} from "@repo/fika-blog/src/nodes/snippet"
import type { NodeViewRendererProps } from "@repo/fika-blog/src/tiptap/core"
import { SnippetView } from "./snippet-view"

export function getEditSnippet(metaProps: {
  translations: SnippetTranslations
}) {
  return Snippet.extend({
    addNodeView() {
      return (props: NodeViewRendererProps) =>
        new SnippetView(
          props.node,
          props.editor.view,
          props.getPos,
          metaProps.translations,
        )
    },
  }).configure({
    translations: metaProps.translations,
  })
}
